package com.bikompanion.ui.models

/**
 * A patch of ground with racks in it, for the map to draw when it is pulled too far back to
 * show them one by one.
 *
 * The counterpart to the network circles the station layer draws at the same zooms, and the
 * reason the two layers can't share them: a blue network circle says "there is a bike-share
 * system here", which is not an answer to "where can I lock my bike".
 */
data class ParkingAreaSummary(
    val latitude: Double,
    val longitude: Double,
    val spotCount: Int,
)
